<template>
	<div @click="clickShopItem(item)">
		<div class="shop-thumbnail">
			<img
				v-if="item.thumb_url"
				:src="item.thumb_url"
				class="shop-thumbnail__thumbnail shop-thumbnail__thumbnail--image"
				alt=""
			/>
			<div
				v-else
				class="shop-thumbnail__thumbnail shop-thumbnail__thumbnail--empty"
			>
				No Image
			</div>
		</div>
		<div class="shop-item-container__title">
			{{ item.shop_name }}
		</div>
	</div>
</template>

<script>
export default {
	props: {
		item: {
			type: Object,
			default: () => {},
			required: true,
		},
	},
	methods: {
		clickShopItem(item) {
			this.$store.dispatch('shopStore/getShopDetail', item);
			this.$store.dispatch('dialogStore/openDialog');
		},
	},
};
</script>

<style scoped>
.shop-thumbnail {
	position: relative;
	padding-top: 70.4%;
	background: #eee;
}

.shop-thumbnail__thumbnail {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
}

.shop-thumbnail__thumbnail--image {
	width: 100%;
	height: 100%;
	object-fit: cover;
}

.shop-thumbnail__thumbnail--empty {
	display: flex;
	justify-content: center;
	align-items: center;
	color: #aaa;
	font-size: 0.875rem;
}

.shop-item-container__title {
	padding: 0.25rem;
	font-size: 0.875rem;
	font-weight: 500;
}
</style>
